module.exports = __webpack_public_path__ + "static/media/trimex_flores.aa3798c6.png";